import { Box } from "@mui/material";
import React, { MouseEvent } from "react";
import { ToolButtonDropdown } from "ui/Scripts/source/components/framework/Button/ToolButtonDropdown";
import { IDropdownAction } from "ui/Scripts/source/components/framework/dropdown";
import { DownloadToolButton } from "source/components/framework/Button/DownloadToolButton";
import { RemoveToolButton } from "source/components/framework/Button/RemoveToolButton";
import { PrintToolButton } from "source/components/framework/Button/PrintToolButton";
import { AppAddIcon } from "source/components/framework/Icon/AppAddIcon";
import { AddToolButton } from "source/components/framework/Button/AddToolButton";
import { EditToolButton } from "source/components/framework/Button/EditToolButton";
import { AppMoreIcon } from "source/components/framework/Icon/AppMoreIcon";
import { Translations } from "ui/Scripts/source/models/translations";

interface ListIconButtonsItemProps {
    stopPropagation?: boolean;
    prefixElement?: React.ReactNode;
    addTooltip?: string;
    editTooltip?: string;
    removeTooltip?: string;
    downloadTooltip?: string;
    printTooltip?: string;
    addDisabled?: boolean;
    editDisabled?: boolean;
    removeDisabled?: boolean;
    downloadDisabled?: boolean;
    printDisabled?: boolean;
    moreDisabled?: boolean;
    addActions?: IDropdownAction[];
    moreActions?: IDropdownAction[];
    onAdd?: (event: MouseEvent<HTMLElement>) => void;
    onEdit?: (event: MouseEvent<HTMLElement>) => void;
    onRemove?: (event: MouseEvent<HTMLElement>) => void;
    onDownload?: (event: MouseEvent<HTMLElement>) => void;
    onPrint?: (event: MouseEvent<HTMLElement>) => void;
}

export const ListIconButtonsItem = ({
    stopPropagation,
    prefixElement,
    addTooltip,
    editTooltip,
    removeTooltip,
    downloadTooltip,
    printTooltip,
    addDisabled,
    editDisabled,
    removeDisabled,
    downloadDisabled,
    printDisabled,
    moreDisabled,
    addActions,
    moreActions,
    onAdd,
    onEdit,
    onRemove,
    onDownload,
    onPrint
}: ListIconButtonsItemProps) => (
    <Box sx={{ marginLeft: ".5rem", display: "flex" }}>
        {prefixElement}
        {onAdd && (
            <AddToolButton onClick={onAdd} tooltip={addTooltip} disabled={addDisabled} />
        )}
        {addActions && addActions.length > 0 && (
            <ToolButtonDropdown
                variant="icon"
                tooltip={addTooltip}
                actions={addActions}
                icon={<AppAddIcon />}
                menuRight={true}
            />
        )}
        {onEdit && (
            <EditToolButton onClick={onEdit} tooltip={editTooltip} disabled={editDisabled} />
        )}
        {onDownload && (
            <DownloadToolButton onClick={onDownload} tooltip={downloadTooltip} disabled={downloadDisabled} />
        )}
        {onRemove && (
            <RemoveToolButton onClick={onRemove} tooltip={removeTooltip} disabled={removeDisabled} />
        )}
        {onPrint && (
            <PrintToolButton onClick={onPrint} tooltip={printTooltip} disabled={printDisabled} />
        )}
        {moreActions && moreActions.length > 0 && (
            <ToolButtonDropdown
                variant="icon"
                actions={moreActions}
                stopPropagation={stopPropagation}
                icon={<AppMoreIcon />}
                tooltip={Translations.AdditionalFunctions}
                menuRight={true}
                disabled={moreDisabled}
            />
        )}
    </Box>
);
